import {ref} from "vue";

export default function () {
    const showEditBlockModal = ref(false);
    const editElement = ref({});
    let passUpdateBlockHTMLCallback;
    const openBlockEditModal = ({element, callback}) => {
        showEditBlockModal.value = true;
        editElement.value = element;
        passUpdateBlockHTMLCallback = callback;
    };

    const updateBlock = (html) => {
        passUpdateBlockHTMLCallback(editElement.value, html);
    }

    return {
        showEditBlockModal,
        editElement,
        openBlockEditModal,
        updateBlock,
    }
}
